import { MagicWandIcon } from '@carboncopyco/icons';
import {
  type Placement,
  TextBase,
  TextCaption,
  Tooltip,
} from '@carboncopyco/ui';
import { isDesktop } from '@carboncopyco/utils';
import type React from 'react';

interface PlaybookPreviewTooltipProps {
  giveADemoRef: React.RefObject<HTMLElement>;
  desktopDomain: string;
  location: Location;
  placement?: Placement;
  playId?: string;
}

export const PlaybookGiveADemoTooltip = ({
  giveADemoRef,
  desktopDomain,
  location,
  placement = 'bottom',
  playId,
}: PlaybookPreviewTooltipProps) => {
  return (
    <>
      {!isDesktop() && (
        <Tooltip
          anchorRef={giveADemoRef}
          placement={placement}
          noArrow
        >
          <div className="p-3 w-56 ">
            <div className="flex flex-row items-center">
              <MagicWandIcon size={16} />
              <div className="pl-1">
                <TextBase
                  label="Tip"
                  color="text-ds-natural-700"
                />
              </div>
            </div>

            <TextCaption label="For optimal presentation experiences, we recommend using the " />
            <a
              href={`${desktopDomain}://navigate${location.pathname}?${
                playId ? `playId=${playId}&mode=play` : 'giveADemo=true'
              }`}
              rel="noreferrer"
              className="text-ds-200 font-ds-inter text-ds-primary-300"
            >
              desktop app
            </a>
            <TextCaption label="." />
          </div>
        </Tooltip>
      )}
    </>
  );
};
